import { render, staticRenderFns } from "./NavigationSectionSubpage.vue?vue&type=template&id=3d87ff94&scoped=true&"
import script from "./NavigationSectionSubpage.vue?vue&type=script&lang=ts&"
export * from "./NavigationSectionSubpage.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationSectionSubpage.vue?vue&type=style&index=0&id=3d87ff94&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d87ff94",
  null
  
)

export default component.exports